// removed by extract-text-webpack-plugin
module.exports = {"heroImage":"src-components----HeroImage-module---heroImage---peY7f","imageZoom":"src-components----HeroImage-module---imageZoom---JhDSC","heroWrapper":"src-components----HeroImage-module---heroWrapper---Lrqjp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeroImage.module.styl
// module id = ./src/components/HeroImage.module.styl
// module chunks = 168707334958949